import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ActionsSection } from '../components/ActionsSection';
import { EcosystemSection } from '../components/EcosystemSection';
import { TeamSection } from '../components/TeamSection';
import { CTASection } from '../components/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="home-page">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ActionsSection />
        <EcosystemSection />
        <TeamSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
